export default "__VITE_ASSET__u1FU45Sv__"